import {jsx} from 'panel';

import {TrackedUserIconEl} from 'common/widgets/tracked-user-icon';
import {RenderValue} from 'common/util/format-property';
import {truncate} from 'common/util/string';

export const UserCellRenderer = ({
  href,
  distinctId,
  email,
  avatar,
  tooltip,
  name,
  emitRowClick,
}: {
  href: string;
  distinctId: string;
  email: string;
  avatar: string;
  tooltip: string;
  name: string;
  emitRowClick: boolean;
}) => {
  return (
    <div sel='.user-info' attrs={{title: tooltip}}>
      <a sel='.mp-avatar' attrs={{href}} on={{click: (ev) => emitRowClick && ev.preventDefault()}}>
        <TrackedUserIconEl attrs={{'img-src': avatar, 'distinct-id': distinctId, email}} />
      </a>
      <a
        sel='.mp-name-link'
        class={{'no-value': !name}}
        attrs={{href, ...(emitRowClick ? {target: `_blank`} : {})}}
        on={{click: (ev) => emitRowClick && ev.preventDefault()}}
      >
        {name || `(No value)`}
      </a>
    </div>
  );
};

export const DataCellRenderer = ({
  rowValue,
  tooltip,
  allowLinks,
}: {
  rowValue: RenderValue;
  tooltip: string;
  allowLinks: boolean;
}) => {
  const renderString = truncate(`${rowValue.renderString}`, 110) || ``;
  return allowLinks && `href` in rowValue ? (
    <a sel='.row-value .row-link' attrs={{href: rowValue.href, target: `_blank`}}>
      {renderString}
    </a>
  ) : (
    <div sel='.row-value' attrs={{title: tooltip}}>
      {renderString}
    </div>
  );
};
